module.exports = __webpack_public_path__ + "img/arrow-down.1e2df1f4.svg";